export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'À qui s’adresse la collection\u00A0?',
    answer:
      'Aux professeurs qui enseignent la musique en français, au primaire comme au secondaire. Chacun choisit les ressources selon ses objectifs et les acquis de ses élèves, puis les adapte à sa classe.',
  },
  {
    question: 'Pour quels âges\u00A0?',
    answer:
      'Pour des élèves d’environ 6 à 18\u00A0ans. Ces repères sont indicatifs\u00A0: la collection progresse par compétences, plutôt que par équivalence automatique avec une classe ou un système scolaire.',
  },
  {
    question: 'Faut-il posséder beaucoup d’instruments\u00A0?',
    answer:
      'Non. De nombreuses activités s’appuient sur la voix, les percussions corporelles ou du matériel courant. Vous choisissez celles qui correspondent à vos moyens. Aucun instrument physique n’est inclus.',
  },
  {
    question: 'Est-ce un produit physique\u00A0?',
    answer:
      'Non. MUSIQUE PRÊTE est une collection de fichiers PDF. Les appareils, livres et instruments visibles sur le visuel illustrent les usages possibles et ne sont pas livrés.',
  },
  {
    question: 'Puis-je imprimer seulement les pages utiles\u00A0?',
    answer:
      'Oui. Les ressources sont au format PDF\u00A0: vous pouvez sélectionner les pages utiles à votre séance pour les imprimer ou les projeter.',
  },
  {
    question: 'Dois-je suivre les dix tomes dans l’ordre\u00A0?',
    answer:
      'Les tomes proposent une progression. Choisissez votre point de départ selon les acquis de vos élèves et votre objectif, puis adaptez les activités à votre groupe.',
  },
  {
    question: 'Est-elle conforme au programme de mon pays\u00A0?',
    answer:
      'MUSIQUE PRÊTE est une collection internationale en français. Il vous revient de sélectionner et d’adapter les ressources au programme en vigueur là où vous enseignez\u00A0: aucune conformité universelle n’est revendiquée.',
  },
  {
    question: 'Les corrigés et l’évaluation sont-ils inclus\u00A0?',
    answer:
      'Oui. Les tomes contiennent des corrigés ou des critères adaptés à chaque type de tâche. Le bonus «\u00A0Évaluer sans tout recommencer\u00A0» ajoute des outils d’évaluation transversaux.',
  },
  {
    question: 'Quels sont les cinq bonus\u00A0?',
    answer:
      '«\u00A0La séance de secours\u00A0», «\u00A0Évaluer sans tout recommencer\u00A0», «\u00A0La musique pour chacun\u00A0», «\u00A0Notre rendez-vous musical\u00A0» et «\u00A0Une classe de musique bien organisée\u00A0». Ils complètent les 10 tomes principaux.',
  },
]
